<template>
  <div class="w20 py-5 px-6">
    <div class="block flex">
      <div class="md:w-2/5 w-4/12 mr-4">
        <div v-if="!session.speakers[1]">
          <router-link :to="speakerurl">
            <div
              :aspeaker="aspeaker"
              v-for="(aspeaker, idx) in portraitImage"
              :key="idx"
            >
              <img
                :src="aspeaker.url"
                :alt="aspeaker.name"
                :title="aspeaker.name"
                class="rounded-full border-2 border-white"
                :class="{ 'border-yellow': live }"
              />
            </div>
          </router-link>
        </div>
        <div v-if="session.speakers[1]">
            <div
                :aspeaker="aspeaker"
                v-for="(aspeaker, idx) in portraitImage"
                :key="idx"
            >
              <img
                  :src="aspeaker.url"
                  :alt="aspeaker.name"
                  :title="aspeaker.name"
                  class="rounded-full border-2 border-white w-1/2 mx-auto"
                  :class="{ 'border-yellow': live }"
              />
            </div>
        </div>


      </div>
      <div class="md:w-3/5 w-8/12">
        <div class="md:text-lg text-sm font-semibold">
          <router-link :to="url">
            <div
              class="uppercase font-bold md:text-lg text-sm text-darkFont hover:text-yellow"
            >
              {{session.shortTitle}}
            </div>
          </router-link>
          <div class="text-darkFont font-normal text-sm">
            with
            <router-link :to="speakerurl">{{session.speakers[0].name}}</router-link>
            <span v-if="session.speakers[1]"> & <router-link :to="speakerurl2">{{session.speakers[1].name}}</router-link></span>
          </div>

          <div class="text-white">
            <span>{{ startTime.hours }}</span>
            <span v-if="startTime.minute !== '00'"
              >:{{ startTime.minute }}</span
            >
            <span class="uppercase">{{ startTime.ampm }}</span>
            <span class="text-sm -mt-1 text-white"> {{ timeZone }}</span>
            <!--<span class="text-sm -mt-1 text-white"> CDT</span>-->
          </div>
        </div>
      </div>
    </div>
    <div class="block flex mb-8">
      <div class="text-darkFont"></div>
      <div class="w-1/12 md:w-2/12 md:px-0 pl-4 pr-5"></div>
      <div
        class="md:w-10/12 w-11/12 border-l-2 border-white ml-3 pl-8 pb-10 border-b-2 rounded-bl-2xl pt-12 z-40 relative"
      >
        <div class="text-darkFont font-normal text-sm md:my-5 my-8">
          <div class="bg-dakGrey absolute lastlogo" v-if="session.productCompatibility">
            <div v-if="session.productCompatibility[0]">
              <session-compatibility-block-small
                :session="session"
              ></session-compatibility-block-small>
            </div>
          </div>
          <span>{{ session.shortDescription }}</span>
          <div class="absolute lastbtn">
            <router-link :to="url">
              <p
                class="w-40 text-center items-center rounded-xl rounded-bl-none justify-center border-2 py-3 border-white text-sm font-bold uppercase rounded-md bg-black text-white focus:outline-none focus:shadow-outline transition duration-150 ease-in-out"
              >
                {{ buttonText }}
              </p>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTimeZoneString, toFriendlyTimeAMPMObj } from "../utils/dateHelpers";
import SessionCompatibilityBlockSmall from "./SessionCompatibilityBlockSmall";
import sanityImageBuilder from "../utils/sanityImageBuilder";

export default {
  name: "PaperAgendaItem",
  components: {
    SessionCompatibilityBlockSmall
  },
  props: {
    session: {
      type: Object,
      require: true
    }
  },
  computed: {
    url() {
      return `/session/${this.session.slug.current}`;
    },

    speakerurl() {
      return `/speaker/${this.session.speakers[0]._id}`;
    },

    speakerurl2() {
      return `/speaker/${this.session.speakers[1]._id}`;
    },

    startTime() {
      return toFriendlyTimeAMPMObj(this.session.startTime);
    },
    timeZone() {
      return getTimeZoneString();
    },
    live() {
      return this.session.watchStatus === "LIVE";
    },
    portraitImage() {
      let portraits = [];
      if ("speakers" in this.session) {
        this.session.speakers.forEach(speaker => {
          portraits.push({
            url: sanityImageBuilder
              .image(speaker.portrait)
              .width(200)
              .height(200)
              .url(),
            name: speaker.name
          });
        });
      }
      return portraits;
    },
    buttonText() {
      switch (this.session.watchStatus) {
        case "IDLE":
          return "More Details";
        case "LIVE":
          return "Watch Now";
        case "COMPLETE":
          return "Watch Again";
        default:
          return "More Details";
      }
    }
  }
};
</script>

<style scoped>
.w20 {
  width: 25rem;
}

.bg-dakGrey {
  background: #bcbcbc;
}

.lastlogo {
  top: 1rem;
  left: -1.35rem;
}

.lastbtn {
  bottom: -1.5rem;
  right: 0;
}

@media only screen and (max-width: 767px) { .w20 { width: 22rem;} .lastlogo { top:1.5rem; } }
</style>
